
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]/asset/[assetId]",
      function () {
        return require("private-next-pages/[chain]/asset/[assetId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[chain]/asset/[assetId]"])
      });
    }
  